import { postWithoutBody, requestJson } from "./http";
import { common, pick } from "./i18n";
import type { GenerationOutputStatus, QaVerdict } from "../types";

type QaVerdictMeta = { color: string; label: string };

const qaLabels = {
  pl: { pass: "wierność OK", review: "do weryfikacji", evaluated: "oceniono" },
  en: { pass: "fidelity OK", review: "needs review", evaluated: "evaluated" },
};

export function qaVerdictMeta(verdict: QaVerdict | null | undefined): QaVerdictMeta {
  const labels = pick(qaLabels);
  if (verdict === "pass") return { color: "#15803d", label: labels.pass };
  if (verdict === "review") return { color: "#b45309", label: labels.review };
  return { color: "var(--muted)", label: labels.evaluated };
}

export function generationStatusLabel(status: GenerationOutputStatus) {
  return common().status[status];
}

export async function cancelGenerationJob(productId: number, jobId: number) {
  await postWithoutBody(`/products/${productId}/generation_jobs/${jobId}/cancel`);
}

export async function retryGenerationOutput(productId: number, jobId: number, outputId: number) {
  await postWithoutBody(`/products/${productId}/generation_jobs/${jobId}/outputs/${outputId}/retry`);
}

export async function regenerateGenerationOutput(productId: number, jobId: number, outputId: number) {
  await postWithoutBody(`/products/${productId}/generation_jobs/${jobId}/outputs/${outputId}/regenerate`);
}

type ManualCorrectionResponse = {
  job_id: number;
  output_id: number;
  mode: string;
  status: GenerationOutputStatus;
};

export async function correctGenerationOutput(productId: number, jobId: number, outputId: number, instruction: string) {
  return requestJson<ManualCorrectionResponse>(
    `/products/${productId}/generation_jobs/${jobId}/outputs/${outputId}/correct`,
    { body: { correction: { instruction } } },
  );
}

export type SpotFixBox = { x: number; y: number; w: number; h: number };

type SpotFixResponse = {
  output_id: number;
  mode: string;
  status: GenerationOutputStatus;
};

export async function spotFixGenerationOutput(
  productId: number,
  jobId: number,
  outputId: number,
  params: { referenceFileId: number; sourceBox: SpotFixBox; referenceBox: SpotFixBox; note: string },
) {
  return requestJson<SpotFixResponse>(
    `/products/${productId}/generation_jobs/${jobId}/outputs/${outputId}/spot_fix`,
    {
      body: {
        spot_fix: {
          reference_file_id: params.referenceFileId,
          source_box: params.sourceBox,
          reference_box: params.referenceBox,
          note: params.note,
        },
      },
    },
  );
}
